/** The picker's footer: "No files selected", "1 file selected", "3 files selected". */
export const selectedFilesText = (n: number): string => (n ? `${n} file${n === 1 ? '' : 's'} selected` : 'No files selected');

/**
 * A project row's counts: "6 folders", "1 folder · 2 files", "3 files", or
 * "Empty" when it has neither. A zero is left out rather than read as "0 files".
 */
export const projectCountsText = (folders: number, files: number): string => {
    const parts: string[] = [];
    if (folders) parts.push(`${folders} folder${folders === 1 ? '' : 's'}`);
    if (files) parts.push(`${files} file${files === 1 ? '' : 's'}`);
    return parts.length ? parts.join(' · ') : 'Empty';
};
